import { Link as MaterialLink, Theme, styled } from '@material-ui/core';
import React from 'react';
import { Link as RouterLink } from 'react-router-dom';
import { MANUAL_BOOKS } from 'src/config/api/models/Book';

const StyledRouterLink = styled(RouterLink)<Theme>(({ theme }) => ({
  textDecoration: 'none',
  color: theme.palette.ternary.main,
  fontWeight: 400,
  marginLeft: theme.spacing(1),
  marginRight: theme.spacing(1),

  '&:focus, &:visited, &:link, &:active': {
    textDecoration: 'none',
  },
  '&:hover': {
    textDecoration: 'underline',
  },
}));

const StyledMaterialLink = styled(MaterialLink)<Theme>(({ theme }) => ({
  color: theme.palette.ternary.main,
  fontWeight: 400,
  marginInline: theme.spacing(1),
}));

const StyledMessage = styled('div')<Theme>(({ theme }) => ({
  margin: theme.spacing(1, 0),
  fontWeight: 400,
  color: theme.palette.secondary.main,
  lineHeight: theme.typography.body1.lineHeight,
  whiteSpace: 'pre-wrap',
  paddingTop: theme.spacing(2),
}));

const bookPreviewTooltips = [
  {
    id: 'knowledgeBase',
    message:
      'In je proefproject kan je geen jaarplannen of toetsen downloaden uit de leraarskamer. And More',
    links: [
      {
        text: '- Leer meer over de leraarskamer',
        type: 'route',
        link: `/nl-be/boekentas/${MANUAL_BOOKS.teacher}/hoofdstukken/c71efefb-c3c7-4599-a7e7-c257cddeafca/traject/dcb21d65-49fe-42f6-a40c-dc04ca14502a/0/opbouw/`,
      },
      {
        text: '- Contacteer ons voor volledige toegang.',
        type: 'url',
        link: 'https://www.digitalemethode.be/contact',
      },
    ],
  },
  {
    id: 'visibility',
    message: 'In je proefproject kan je leertrajecten niet onzichtbaar zetten voor leerlingen.',
    links: [
      {
        text: '- Leer meer over het (on)zichtbaar zetten van leertrajecten.',
        type: 'route',
        link: `/nl-be/boekentas/${MANUAL_BOOKS.teacher}/hoofdstukken/c71efefb-c3c7-4599-a7e7-c257cddeafca/traject/8f3e49a0-510a-4bd6-b6b6-937f68594d55/0/opbouw/`,
      },
      {
        text: '- Contacteer ons voor volledige toegang. Zo kan je het testen met je leerlingen.',
        type: 'url',
        link: 'https://www.digitalemethode.be/contact',
      },
    ],
  },
  {
    id: 'scores',
    message: 'In je proefproject kan je geen scores van leerlingen opvolgen.',
    links: [
      {
        text: '- Leer meer over scores opvolgen.',
        type: 'route',
        link: `/nl-be/boekentas/${MANUAL_BOOKS.teacher}/hoofdstukken/c71efefb-c3c7-4599-a7e7-c257cddeafca/traject/a1a59714-690e-4ea0-aa75-ea20b7fda9df/0/opbouw/`,
      },
      {
        text: '- Contacteer ons voor volledige toegang. Zo kan je het testen met je leerlingen',
        type: 'url',
        link: 'https://www.digitalemethode.be/contact',
      },
    ],
  },
  {
    id: 'progress',
    message: 'In je proefproject kan je de progressie van leerlingen niet opvolgen.',
    links: [
      {
        text: '- Leer meer over progressie.',
        type: 'route',
        link: `/nl-be/boekentas/${MANUAL_BOOKS.teacher}/hoofdstukken/c71efefb-c3c7-4599-a7e7-c257cddeafca/traject/a1a59714-690e-4ea0-aa75-ea20b7fda9df/0/opbouw/`,
      },
      {
        text: '- Contacteer ons voor volledige toegang. Zo kan je het testen met je leerlingen',
        type: 'url',
        link: 'https://www.digitalemethode.be/contact',
      },
    ],
  },
];

export const blockedButtonTooltip = (
  id: string,
  message: string,
  links: { text: string; type: string; link: string }[]
) => {
  return {
    id: id,
    message: (
      <StyledMessage id={id + 'filterButton'}>
        {message}
        <ul style={{ listStyleType: 'none', padding: 0 }}>
          {links.map((entry: { text: string; type: string; link: string }, index) => (
            <li key={`link-${index}`}>
              {entry.type === 'route' ? (
                <StyledRouterLink to={entry.link}>{entry.text}</StyledRouterLink>
              ) : (
                <StyledMaterialLink
                  href={entry.link}
                  underline="hover"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  {entry.text}
                </StyledMaterialLink>
              )}
            </li>
          ))}
        </ul>
      </StyledMessage>
    ),
  };
};

export const BlockedFilters = () =>
  bookPreviewTooltips.map((filter) =>
    blockedButtonTooltip(filter.id, filter.message, filter.links)
  );
